// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".no-admin-menu {\n    margin-left: unset;\n    margin-top: -40px;\n}", "",{"version":3,"sources":["webpack://src/pages/Internal/internal.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,iBAAiB;AACrB","sourcesContent":[".no-admin-menu {\n    margin-left: unset;\n    margin-top: -40px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
